import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatTableDataSource, MatSort, Sort, PageEvent, MatExpansionPanel, MatDialog } from '@angular/material';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { VolverService } from '../../../providers/volver.service';
import { CotizacionService } from '../../../providers/cotizacion.service';
import { OrdenVentaComponent } from '../orden-venta.component';
import { TipoABM } from '../../../interfaces/tipo-abm';
import { ImprimirComponent } from '../imprimir/imprimir.component';
import { ConfirmComponent } from '../../../components/confirm/confirm.component';
import { ZerosPipe } from '../../../pipes/transforms/zeros.pipe';
import { AsignacionStockComponent } from '../asignacion-stock/asignacion-stock.component';
import { ImprimirAsignacionComponent } from '../asignacion-stock/imprimir-asignacion/imprimir-asignacion.component';

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss']
})
export class TablaComponent implements AfterViewInit {
  TipoABM: TipoABM = new TipoABM();
  readonly titulo = 'orden-venta';
  getSuscripcion = new Subscription();
  dataSource = new MatTableDataSource();
  cargando: boolean[] = []; // para mostrar el progress-bar luego de un tiempo de busqueda
  @ViewChild(MatSort) matSort: MatSort;
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  // true si hay almenos un filtro activo
  panelConFiltroActivo = false;
  tieneFiltrosOrdenPaginado = false;
  filtros: any = {
    generico: ''
  };
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this._checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 25);
    }
  };
  columnas = [
    'id',
    'numero',
    'cliente',
    'estado',
    'vencimiento',
    'archivos',
    'acciones'
  ];
  total: number = 0;

  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  private _setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  /**
   * olvidar el estado de la página
   */
  private _limpiarPageState() {
    // filtros
    localStorage.setItem('ver_' + this.titulo + '_filtros', null);
    // paginado
    localStorage.setItem('ver_' + this.titulo + '_paginado', null);
    // sort
    localStorage.setItem('ver_' + this.titulo + '_sort', null);
  }

  /**
   * recuerda el estado de la página por si vuelven a ingresar
   * y hay que mostrarla tal cual como estaba
   */
  private _recordarPageState() {
    // filtros
    localStorage.setItem('ver_' + this.titulo + '_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_' + this.titulo + '_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_' + this.titulo + '_sort', JSON.stringify(this.sort));
  }

  /**
   * restaudar la página al estado en que estaba
   */
  private _restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_' + this.titulo + '_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_' + this.titulo + '_paginado'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_' + this.titulo + '_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_' + this.titulo + '_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this._setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this._setActiveSortProgrammatically('fecha_alta', 'desc');
    }
    this.actualizarTabla();
  }

  /**
   * revisa las variables de page state para ver
   * si hay almenos una aplicada ya sea filtrado, paginado u ordenamiento
   */
  private _checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fecha_alta' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }

    return this.tieneFiltrosOrdenPaginado;
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_' + this.titulo + '_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  /**
   * limpia las variables de page state
   * y luego restaura el estado al estado inicial
   */
  reiniciarPageState() {
    this._limpiarPageState();
    this._restaurarPageState();
  }

  constructor(
    private _cmSv: ComunicacionService,
    private _cotizacionSv: CotizacionService,
    private _volverSv: VolverService,
    private _dialog: MatDialog,
    private _zerosPipe: ZerosPipe,
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this._volverSv.usaronBotonVolver()) {
        this._restaurarPageState();
      } else {
        this.reiniciarPageState();
      }
    });
  }

  actualizarTabla(): void {
    if (this.getSuscripcion && !this.getSuscripcion.closed) {
      this.cargando.pop();
      this.getSuscripcion.unsubscribe();
    }
    this.cargando.push(true);
    this._recordarPageState();
    this._checkPageState();
    this.getSuscripcion = this._cotizacionSv.getOrdenesVenta(
      {
        page: this.page.pageIndex,
        pageSize: this.page.pageSize
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      { ...this.filtros, ...{ estadoCotizacion: this._cotizacionSv.ESTADO_AUTORIZADA } }
    ).subscribe(
      (respuesta) => {
        const data = this._cmSv.format(respuesta, false);
        if (data != this._cmSv.SIN_DATA) {
          this.dataSource.data = data.ordenes;
          this.total = data.total;
        }
      },
      () => {
        this.cargando.pop();
      },
      () => {
        this.cargando.pop();
      }
    );
  }

  ngOnDestroy() {
    if (this.getSuscripcion && !this.getSuscripcion.closed) {
      this.getSuscripcion.unsubscribe();
    }
  }

  editar = (model) => {
    this._dialog.open(OrdenVentaComponent, {
      disableClose: true,
      minWidth: '840px',
      data: {
        tipoABM: this.TipoABM.MODIFICACION,
        titulo: 'OPERACIÓN DE VENTA',
        model: model
      }
    }).afterClosed().subscribe((respuesta) => {
      this.actualizarTabla();
    });
  }

  solicitarAceptacion = (model) => {
    this._dialog.open(ConfirmComponent, {
      minWidth: '360px',
      data: {
        texto: 'Confirme si desea <b>SOLICITAR ACEPTACIÓN</b> de la operación <b>' + this._zerosPipe.transform(model.id, 7) + '</b>',
        botones: [
          {
            label: 'CONFIRMAR',
            color: 'accent',
            action: () => {
              this.cargando.push(true);
              this._dialog.closeAll();
              this._cotizacionSv.solicitarAceptacion(model).subscribe(
                (respuesta) => {
                  this.cargando.pop();
                  const data = this._cmSv.format(respuesta, true);
                  if (data != this._cmSv.SIN_DATA) {
                  }
                  this.actualizarTabla();
                },
                () => {
                  this.cargando.pop();
                  this._dialog.closeAll();
                }
              );
            }
          },
          {
            label: 'CANCELAR',
            action: () => {
              this._dialog.closeAll();
            }
          }
        ]
      }
    });
  }

  asignacion = (model) => {
    this._dialog.open(AsignacionStockComponent, {
      disableClose: true,
      minWidth: '980px',
      data: {
        model: model
      }
    }).afterClosed().subscribe((respuesta) => {
      this.actualizarTabla();
    });
  }

  imprimirOperacion = (model) => {
    this._dialog.open(ImprimirComponent, {
      minWidth: '480px',
      data: {
        model: model
      }
    }).afterClosed().subscribe((respuesta) => {
      this.actualizarTabla();
    });
  }

  imprimirAsignacionStock = (model) => {
    this._dialog.open(ImprimirAsignacionComponent, {
      minWidth: '480px',
      data: {
        model: model
      }
    }).afterClosed().subscribe((respuesta) => {
      this.actualizarTabla();
    });
  }
}
